(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.spotScroll = function(){
    var base = this;

    base.spotsArray = [];
    base.nChilds = 0;
    base.attachment = false;

    base.init = function(){

      if ($(window).width() > 768) {
        base.run();
      };

    };

    base.setSpotPosition = function() {
      base.spotsArray = [];
      base.nChilds = 0;
      $('.js-spot-image').each(function(i, el){
        base.spotsArray[i] = [];
        base.spotsArray[i]['top'] = $(el).offset().top;
        base.nChilds++;
      });
    };

    base.run = function(){
      var top = $(window).scrollTop();
      base.setSpotPosition();

      if (top >= base.spotsArray[0]['top'] && top < base.spotsArray[base.nChilds-1]['top']) {
        if (!base.attachment){
          $('.js-spot-image').addClass('c-spot__image--attachment');
          base.attachment = true;
        }
      } else {
        if (base.attachment){
          $('.js-spot-image').removeClass('c-spot__image--attachment');
          base.attachment = false;
        }
      }

    };

    base.init();

    $(window).on('scroll', function(){
      if ($(window).width() > 768) {
        base.run();
      };
    });

    $(window).on('resize', function(){
      if ($(window).width() > 768) {
        base.run();
      };
    });

  };

  $( document ).ready(function() {
    if(!$.gnv.mobileAndTabletcheck() && $('.js-spot-image').length && $('.js-spot-svg').length==0)
      $.gnv.spotScroll();
  });

})(jQuery);




